<template>
  <v-dialog persistent v-model="show">
    <v-toolbar>
      <v-btn @click="close" class="btn-search">返回</v-btn>
    </v-toolbar>
    <div v-html="mailBody"></div>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      mailBody: {}
    }
  },
  methods: {
    popup(body) {
      this.show = true
      this.mailBody = body
    },
    close() {
      this.show = false
    }
  }
}
</script>
